/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Spaces_Edit_User_Permissions_DescriptionInputs */



/**
* | output |
* | --- |
* | "Update permissions for {email}" |
*
* @param {Spaces_Edit_User_Permissions_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_edit_user_permissions_description = /** @type {((inputs: Spaces_Edit_User_Permissions_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Edit_User_Permissions_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Berechtigungen für ${i?.email} aktualisieren`)
	return /** @type {LocalizedString} */ (`Update permissions for ${i?.email}`)
});